import { Carousel } from "../components/Carousel";
import { VideoCard } from "../components/VideoCard";
import { trayectoriaVideos, moraVideos, conferenciasSlides } from "../data/content";
import type { VideoItem } from "../types";

export function VideosSection({ openVideo }: { openVideo: (v: VideoItem) => void }) {
	return (
		<section className="section">
			<div className="content-wrap reveal">
				<div className="section__label">Archivo audiovisual</div>
				<h2 className="section__heading">Su voz y su trabajo en video.</h2>
				<p className="section__intro">
					Los archivos mostrados son sólo una parte de muchos otros relacionados
					con la vida y obra de Stefanny.
				</p>
			</div>
			<div className="content-wrap--wide">
				<div className="video-grid">
					{trayectoriaVideos.map((v, i) => (
						<VideoCard item={v} onOpen={openVideo} key={i} />
					))}
				</div>
			</div>

			<div className="content-wrap reveal">
				<div className="section__label">Instituto Mora</div>
				<p className="section__intro">
					Reconocimiento al trabajo y esfuerzo de Stefanny en la Unidad de Género
					del Instituto de Investigaciones Dr. José María Luis Mora.
				</p>
			</div>
			<div className="content-wrap--wide">
				<div className="video-grid">
					{moraVideos.map((v, i) => (
						<VideoCard item={v} onOpen={openVideo} key={i} />
					))}
				</div>
				<Carousel slides={conferenciasSlides} title="Conferencias" />
			</div>
		</section>
	);
}
